<script lang="ts">
  import * as _ from "lodash";
  import type { SalesRep } from "@shared/types/SalesRep";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2.js";

  export let salesRep: SalesRep;
  export let assigned: boolean;
  export let currentUserRole: string;
  const canDelete = ["distributor_admin", "payments_admin"].includes(currentUserRole);
  $: canAssign =
    currentUserRole === "manager" &&
    !_.find(salesRep.current_user_managed_reps, { id: salesRep.id });
  $: canUnassign =
    currentUserRole === "manager" &&
    !!_.find(salesRep.current_user_managed_reps, { id: salesRep.id });

  const assignSalesRep = async () => {
    try {
      await HttpPromise({
        method: "POST",
        url: "/api/distributor/sales_rep_manager_assignments",
        data: { sales_rep_id: salesRep.id },
      });
      assigned = true;
      salesRep.current_user_managed_reps = [
        ...salesRep.current_user_managed_reps,
        { id: salesRep.id },
      ];
      Flash.now({ type: "success", message: "You are now managing this sales rep." });
    } catch (_) {
      Flash.now({ type: "error", message: "There was an error assigning the sales rep." });
    }
  };

  const unassignSalesRep = async () => {
    try {
      await HttpPromise({
        method: "POST",
        url: "/api/distributor/sales_rep_manager_assignments/destroy",
        data: { sales_rep_id: salesRep.id },
      });
      assigned = false;
      salesRep.current_user_managed_reps = salesRep.current_user_managed_reps.filter(
        i => i?.id !== salesRep.id
      );
      Flash.now({ type: "success", message: "You are no longer managing this sales rep." });
    } catch (_) {
      Flash.now({ type: "error", message: "There was an error unassigning the sales rep." });
    }
  };

  const deleteSalesRep = async () => {
    if (confirm("Are you sure you want to remove this employee?")) {
      try {
        await HttpPromise({
          method: "DELETE",
          url: `/api/distributor/sales_reps/${salesRep.id}`,
        });
        Flash.now({ type: "success", message: "Employee successfully deleted." });
        window.location.href = "/distributor/sales_reps";
      } catch (_) {
        Flash.now({
          type: "error",
          message: "There was an error while deleting the employee. Please try again.",
        });
      }
    }
  };
</script>

{#if canDelete}
  <button class="fizz-button-danger delete-rep-button" on:click={deleteSalesRep}
    >Remove Account</button
  >
{/if}
{#if assigned && canUnassign}
  <button
    class="fizz-button-danger delete-rep-button unassign-rep-button"
    on:click={unassignSalesRep}>Unassign</button
  >
{:else if !assigned && canAssign}
  <button class="fizz-button assign-rep-button" on:click={assignSalesRep}>Assign to me</button>
{/if}
